module.exports = __webpack_public_path__ + "cfa3e25cd6498904104a171cc3a9f0f1.jpg";